import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, Users, ArrowUpRight, Dot } from 'lucide-react';
import { Button } from './ui/button';
import { RECRUITMENT_ROLES, HERO_IMAGES } from '../mock';

const RecruitmentCTA = () => {
  return (
    <section id="join" data-testid="recruitment-section" className="relative bg-[#0A1628] py-20 md:py-28 overflow-hidden">
      {/* Background truck image */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_IMAGES.ops}
          alt="Excelence Inc driver team and auto transport operations"
          className="w-full h-full object-cover opacity-20 mix-blend-luminosity"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1628] via-[#0A1628]/92 to-[#0A1628]/70" />
      </div>
      <div className="absolute -top-40 -right-40 w-[30rem] h-[30rem] rounded-full bg-[#D4A24C]/15 blur-3xl z-0" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left: copy + CTAs */}
          <div className="text-white">
            <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#D4A24C]">Join the team</span>
            <h2 className="mt-3 text-3xl md:text-5xl font-extrabold leading-[1.05] mb-5">
              Drive With <span className="text-[#2AA8E8]">Excelence</span> <span className="gold-text">Inc.</span>
            </h2>
            <p className="text-base md:text-lg text-white/75 leading-relaxed max-w-xl mb-8">
              We are actively growing our network of road professionals and office coordinators. If you take pride in how you work, we want to hear from you.
            </p>

            <div className="flex flex-wrap gap-3">
              <Link to="/drivers">
                <Button data-testid="recruit-driver-btn" className="btn-accent font-bold h-12 px-6 gap-2">
                  <Truck className="w-4 h-4" /> Join Driver Waitlist
                  <ArrowUpRight className="w-4 h-4" />
                </Button>
              </Link>
              <Link to="/careers">
                <Button data-testid="recruit-coordinator-btn" variant="outline" className="h-12 px-6 border-white/30 text-white bg-white/5 hover:bg-white hover:text-[#0A1628] font-semibold gap-2 backdrop-blur-sm">
                  <Users className="w-4 h-4" /> Become Logistics Coordinator
                </Button>
              </Link>
            </div>
          </div>

          {/* Right: roles list */}
          <div className="relative">
            <div className="bg-gradient-to-br from-white/[0.06] to-white/[0.02] border border-white/10 rounded-3xl p-6 md:p-8 backdrop-blur-sm">
              <div className="flex items-center justify-between mb-5">
                <div className="text-[11px] font-bold uppercase tracking-widest text-[#2AA8E8]">Now hiring</div>
                <div className="flex items-center gap-1 text-[11px] font-bold uppercase tracking-widest text-white/60">
                  <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
                  Live openings
                </div>
              </div>
              <ul className="space-y-2">
                {RECRUITMENT_ROLES.map((role) => (
                  <li
                    key={role}
                    className="group flex items-center justify-between gap-4 px-4 md:px-5 py-3.5 md:py-4 rounded-xl bg-[#0A1628]/60 border border-white/10 hover:border-[#D4A24C]/60 hover:bg-[#0A1628] transition-colors"
                  >
                    <div className="flex items-center gap-3">
                      <Dot className="w-5 h-5 text-[#D4A24C]" />
                      <span className="text-base md:text-lg font-bold text-white">{role}</span>
                    </div>
                    <ArrowUpRight className="w-4 h-4 text-white/40 group-hover:text-[#D4A24C] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
                  </li>
                ))}
              </ul>
              <div className="mt-5 pt-5 border-t border-white/10 flex items-center gap-3 text-xs text-white/60">
                <div className="w-8 h-8 rounded-full bg-[#2AA8E8]/20 border border-[#2AA8E8]/40 flex items-center justify-center">
                  <Users className="w-3.5 h-3.5 text-[#2AA8E8]" />
                </div>
                Competitive rates · On-time pay · Professional dispatch support
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecruitmentCTA;
